import type { ReactNode } from 'react';

export function NavSection({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="mt-3 px-3 pb-1 text-[10px] font-mono uppercase tracking-wider text-text-muted">
      {children}
    </div>
  );
}
